jQuery(document).ready(function ($) {
    async function load() {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        if (cart.items.length === 0) {
            return;
        }

        const skus = cart.items.map(item => item.sku);

        const skusString = skus.map(sku => `sku: '${sku}'`).join(' OR ');

        const query = `
            #graphql
            query products {
                products(first: 100, query: "${skusString}") {
                    edges {
                        node {
                            id
                            handle
                            title
                            metafield(namespace: "global", key: "incoming_date") {
                                type
                                value
                            }
                            variants(first: 10) {
                                edges {
                                    node {
                                        id
                                        title
                                        availableForSale
                                        quantityAvailable
                                        sku
                                        metafield(namespace: "global", key: "incoming_date") {
                                            type
                                            value
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `;

        const queryResponse = await fetch(theme.routes.storefrontAPI, {
            crossDomain: true,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': '949d9e512aefae21c564449dfbfe09e5',
            },
            body: JSON.stringify({
                query: query,
            }),
        });

        const queryData = await queryResponse.json();
        const edges = queryData.data.products.edges;

        const preOrderedItems = edges.filter(edge => {
            const foundNodeWithPreorderMeta = edge.node.variants.edges.find(variant => variant.node.availableForSale && variant.node.quantityAvailable <= 0);
            return foundNodeWithPreorderMeta !== null;
        });
        
        const packs = document.querySelectorAll('._6zbcq51i._6zbcq51h._1fragem28._1fragem1t._6zbcq51l._6zbcq510._6zbcq51k');

        packs.forEach((el, key) => {
            const title = $(el).find('._1tx8jg70._1fragemlt._1tx8jg7c._1tx8jg7b._1fragemo8._1tx8jg715._1tx8jg71d._1tx8jg71f');
            const variantTitle = $(el).find('._1tx8jg70._1fragemlt._1tx8jg7a._1tx8jg79._1fragemo7._1tx8jg715._1tx8jg71e._1tx8jg71f');

            const foundVariant = null;

            const found = preOrderedItems.find(item => {
                const { node } = item;
                return node.title === title.text() && node.variants.edges.some(item2 => {
                    if (item2.node.title === variantTitle.text()) {
                        foundVariant = item2.node;
                        return true;
                    }
                    return false;
                });
            });

            if (found) {
                const result = (typeof foundVariant.metafield === 'object') 
                    ? foundVariant.metafield.value
                    : ((typeof foundVariant.metafield === 'string') ? foundVariant.metafield : '');

                if (result) {
                    variantTitle.after(`
                        <div class="pdp-packs-table__row-dispatch-from" style="padding: 0px !important;">
                            Dispatch from: <span class="is-pre-order">${result}</span>
                        </div>
                    `);
                } else {
                    console.warn(`Incoming date metafield fromt ${foundVariant.title} is not found or empty.`);
                }
            }
        });
    }

    if (document.title.includes('Checkout')) {
        load();
    }
})